import { Fazenda } from './fazenda.model';

export class UsuarioFazenda {
    public cdUsuarioFazenda: number;
    public cdUsuario: number;
    public cdFazenda: number;
    public fazenda: Fazenda;
}
